module.exports = __webpack_public_path__ + "static/media/institute-9-min.da36013f.webp";